<template>
  <div class="app" id="app">
    <div class="container">
      <div class="app__active">
        <div class="app__active-text">
          <p class="text title">KАМЕРГЕР</p>
          <p class="text event">EVENT</p>
        </div>
        <button
          v-if="onReader"
          class="btn__active"
          @click="onReader = !onReader"
        >
          Отключить
        </button>
        <button v-else class="btn__active" @click="onReader = !onReader">
          Отсканировать
        </button>
        <BarcodeReader
          v-if="onReader"
          class="app__barcode"
          :isTrue="onReader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BarcodeReader from "./components/BarcodeReader";

export default {
  name: "App",
  components: {
    BarcodeReader,
  },
  data() {
    return {
      onReader: false,
    };
  },
  methods: {
    hideAddressBar() {
      if (!window.location.hash) {
        if (document.height < window.outerHeight) {
          document.body.style.height = window.outerHeight + 50 + "px";
        }
        setTimeout(function () {
          window.scrollTo(0, 1);
        }, 50);
      }
    },
  },
  mounted() {
    this.hideAddressBar();
  },
};
</script>

<style>
@font-face {
  font-family: "KudryashevDisplayWebContrast";
  src: url("https://spa-bitrix.ru/engeo-development/kamerger/barcode-reader/fonts/kudryashev-display_contrast.woff2")
      format("woff2"),
    url("https://spa-bitrix.ru/engeo-development/kamerger/barcode-reader/fonts/kudryashev-display_contrast.woff")
      format("woff");
  font-weight: normal;
  font-style: normal;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.app {
  background: center / cover no-repeat
    url(https://spa-bitrix.ru/engeo-development/kamerger/barcode-reader/logo/background.png);
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-left: 25px;
  padding-right: 25px;
}
.app__active {
  display: flex;
  flex-direction: column;
}

.app__active-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 75px;
}
.title {
  font-size: 30px;
  letter-spacing: 19px;
}
.event {
  font-size: 60px;
  letter-spacing: 24px;
}
.text {
  margin: 0;
  font-family: "KudryashevDisplayWebContrast";
  color: white;
  font-weight: 400;
}
.btn__active {
  padding: 5px;
  margin-bottom: 20px;
  color: #e5e2df;
  font-family: KudryashevDisplayWebContrast;
  font-size: 4vh;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 5px;
  border-radius: 10px;
  background-color: inherit;
}
@media (min-width: 750px) {
  .title {
    font-size: 60px;
    letter-spacing: 20px;
  }
  .event {
    font-size: 110px;
    letter-spacing: 24px;
  }
}
</style>
